import axiosInstance, {
  axiosAlertInstance,
  axiosInventoryInstance,
} from '@/config/apiConfig';
import { AxiosResponse } from 'axios';
import { API_URL_CONFIG } from '@/config/urlConfig/apiUrlConfig';
import { VDI_VERSION } from '@/constant/gatewayTransaction/gatewayTransaction.constant';
import {
  IApiResponse,
  IDashboard,
  IDashboardVdiTransactionsCount,
  IDashboardVdiMetrics,
  IDashboardAlertMetrics,
  IVdiMetricsApiResponse,
  IAlertMetricsApiResponse,
} from './dashboard.type';

export const fetchVdiTransaction = ({
  startDate,
  endDate,
  version = VDI_VERSION[1]?.id,
  selectedTimezone,
}: IDashboardVdiTransactionsCount): Promise<AxiosResponse<IApiResponse, any>> => {
  return axiosInstance({
    url: API_URL_CONFIG.DASHBOARD.GET_VDI_TRANSACTION,
    params: { version, startDate, endDate, selectedTimezone },
  });
};

/**
 * Fetch VDI metrics for a single type from the new per-type endpoint.
 * URL: GET /v1/vdi2/reports/getVDIMetrics/{type}
 * Params: startDate, endDate, selectedTimezone, groupBy
 */
export const fetchVdiMetrics = ({
  type,
  startDate,
  endDate,
  selectedTimezone,
  groupBy,
}: IDashboardVdiMetrics): Promise<AxiosResponse<IVdiMetricsApiResponse, any>> => {
  return axiosInstance({
    url: `${API_URL_CONFIG.DASHBOARD.GET_VDI_METRICS}/${type}`,
    params: {
      version: VDI_VERSION[1].id, // interceptor uses this to select vdi2 base path
      startDate,
      endDate,
      selectedTimezone,
      groupBy,
    },
  });
};

export const fetchQuikpickProduct = ({
  startDate,
  endDate,
}: IDashboard): Promise<AxiosResponse<IApiResponse, any>> => {
  return axiosInventoryInstance({
    url: API_URL_CONFIG.DASHBOARD.GET_QUIK_PICK,
    params: { startDate, endDate },
  });
};

export const fetchAlert = ({
  startDate,
  endDate,
}: IDashboard): Promise<AxiosResponse<IApiResponse, any>> => {
  return axiosAlertInstance({
    url: API_URL_CONFIG.DASHBOARD.GET_ALERT,
    params: { startDate, endDate },
  });
};

/**
 * Fetch aggregated alert metrics from:
 * GET /v1/alerts/reports/getAlertsMetrics
 * Params: startDate, endDate, selectedTimezone, groupBy
 */
export const fetchAlertMetrics = ({
  startDate,
  endDate,
  selectedTimezone,
  groupBy,
}: IDashboardAlertMetrics): Promise<AxiosResponse<IAlertMetricsApiResponse, any>> => {
  return axiosAlertInstance({
    url: API_URL_CONFIG.DASHBOARD.GET_ALERT_METRICS,
    params: { startDate, endDate, selectedTimezone, groupBy },
  });
};

export const fetchSmartCoolerProduct = (
  _params: IDashboard,
): Promise<AxiosResponse<IApiResponse, any>> => {
  return axiosInventoryInstance({
    url: API_URL_CONFIG.DASHBOARD.GET_SMART_COOLER_PRODUCT_COUNT,
    params: {},
  });
};
